/**
 * Where the app sends microphone audio and asks for the tutor's voice.
 *
 * Served by `services/speech`, which gives AIRI the OpenAI shape its
 * `openai-compatible-audio-*` providers expect and forwards to what already
 * runs on the host: Whisper on the GPU for recognition, steamTTS for synthesis.
 *
 * Its own hostname behind Nginx Proxy Guard, alongside the passage bank's.
 * Override at build time with `VITE_SPEECH_API_BASE_URL`, which is also how the
 * verification run points at a local instance.
 */
export const speechApiBaseUrl = (
  import.meta.env.VITE_SPEECH_API_BASE_URL || 'https://speech.mscbrain.co.kr'
).replace(/\/+$/, '')

/**
 * Bearer token for the gateway.
 *
 * NOTICE:
 * This must be non-empty, and not only for authentication. AIRI treats an audio
 * provider with a blank key as unconfigured, and a watcher in the speech store
 * then resets the selection to `speech-noop` — the tutor silently loses its
 * voice a moment after the character card sets it.
 * Source/context: packages/stage-ui/src/stores/modules/speech.ts, the
 * `configuredSpeechProvidersMetadata` watcher.
 * Removal condition: none while that watcher exists.
 *
 * Recoverable from the APK, like the LLM key. Rotate it rather than rely on it
 * staying secret; it must match `SPEECH_API_KEY` on the gateway.
 */
export const speechApiKey = import.meta.env.VITE_SPEECH_API_KEY || 'vLf8RmTKJs7yklr2mjGWrRo3kkTacFZHvpkG6yXxDa1KauSx'

/** The synthesis engine the gateway is configured with. */
export const speechModel = 'voxcpm'

/** The recognition checkpoint the gateway loads. */
export const transcriptionModel = 'openai/whisper-large-v3-turbo'
